import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"
// import notice from "./notice"
import createPersistedState from 'vuex-persistedstate'


export default {
    state,
    mutations,
    getters,
    actions,
    // modules:{
    //   notice
    // },
    plugins: [createPersistedState({
        storage: window.sessionStorage
    })]
}



// WEBPACK FOOTER //
// ./src/store/index.js